import { Injectable } from '@angular/core';
import { BreadCrumbAction, MenuItemAdvanced } from '@boma/client-shared';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private itemsSource = new Subject<MenuItem[]>();
  itemsHandler = this.itemsSource.asObservable();

  private actions = new Subject<BreadCrumbAction[]>();
  actionHandler = this.actions.asObservable();

  setItems(items: MenuItemAdvanced[], actions?: BreadCrumbAction[]) {
    this.itemsSource.next(items);
    this.actions.next(actions);
  }
}
